<div class="d-flex myside-menu-container" >
    <div class="nav flex-lg-column nav-pills px-1" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <button (click)="goBack()" class="nav-link btn-link" type="button" role="tab">
                    <i class="bx bx-arrow-back fs-5"></i>
                </button>

                <button [class]="getClass('list')" type="button" role="tab" [routerLink]="['/uiformlist/' + uiformId]">
                    <i class="fa fa-list" title="Form List"></i>
                </button>

                  <button [class]="getClass('edit')" type="button" role="tab" [routerLink]="routerLinkPath">
                    <i class="bi bi-card-heading fs-5 p-0" title="Form"></i>
                </button>

                <button [class]="getClass('chart')" data-bs-toggle="pill" type="button" role="tab"
                    [routerLink]="['/uiformchart/' + uiformId]">
                    <i class="fas fa-chart-pie" title="Quick Chart"></i>
                </button>

                <button [class]="getClass('pivot')" data-bs-toggle="pill" type="button" role="tab"
                    [routerLink]="['/uiformpivot/' + uiformId]">
                    <i class="fadeIn animated bx bx-table bx-sm-1" title="Report"></i>
                </button>

                <button [class]="getClass('info')" type="button" role="tab" [routerLink]="['/uiforminfo/' + uiformId]">
                    <i class="fa fa-info-circle" aria-hidden="true" title="Info"></i>
                </button>

                 <button [class]="getClass('jasper')" type="button" role="tab" [routerLink]="['/jasper', uiformId]">
                  <span title="Jasper Report">Ⓡ</span>
                </button>

        <!-- <button [class]="getClass('aireport')" type="button" role="tab" [routerLink]="['/aireport', uiformId]">
             <img src="assets/images/icons/ai-icon.svg" alt="">            
        </button> -->
        <button [class]="getClass('aireport')" type="button" role="tab" [routerLink]="['/aireport', uiformId]">
            <img [src]="getAiIcon('aireport')" alt="AI" width="25" title="AI Report">
        </button>
      
        <button [class]="getClass('taskboard')" type="button" role="tab"  [routerLink]="['/taskboard', uiformId]">
            <i class="fas fa-network-wired" aria-hidden="true" title="Taskboard"></i>
        </button>


            </div>
        </div>
